import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import BundleOutWardService from '../services/bundle-outword';
import { setMessage } from './message';

export const fetchBundleOutWardList = createAsyncThunk('bundleoutword/fetchBundleOutWardList',
  async ({ page, pagesize, search, ordering, workOrderId, start_date, end_date }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.getBundleOutWardList(page, pagesize, search, ordering, workOrderId, start_date, end_date);
      return response.data; 
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchBundleOutWardListById = createAsyncThunk(
  'bundleoutword/fetchBundleOutWardListById',
  async ({ id }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.getBundleOutWardListById(id);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);



export const fetchBundleOutwardPackingSlipData = createAsyncThunk(
'bundleoutword/fetchBundleOutwardPackingSlipData',
  async ({ id }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.getBundlePackingSlipData(id);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchBundleOutwardPackingSlipbundles = createAsyncThunk(
  'bundleoutword/fetchBundleOutwardPackingSlipbundles',
  async ({ id }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.getBundlePackingSlipbundle(id);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchPartyPrintBundleOutWardById = createAsyncThunk(
  'bundleoutword/fetchPartyPrintBundleOutWardById',
  async ({ id, page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.getBundleOutWardById(
        id,
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data; // Return the profile data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchBundleOutwardById = createAsyncThunk(
  'bundleoutword/fetchBundleOutwardById',
  async ({ outward_id, page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.getBundleOutWardByIdFinalize(
        outward_id,
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data; // Return the profile data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchBundleOutWardListByItem = createAsyncThunk(
  'bundleoutword/fetchBundleOutWardListByItem',
  async ({ page, pagesize, search, id, ordering, workOrderId, bundleOutwardId }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.getBundleOutWardByItem(
        page,
        pagesize,
        search,
        id,
        ordering,
        workOrderId,
        bundleOutwardId
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchBundleOutWardByWorkOrderId = createAsyncThunk(
  'bundleoutword/fetchBundleOutWardByWorkOrderId',
  async (
    { page, pagesize, search, id, ordering, workOrderId, addData, bundleOutwardId },
    thunkAPI,
  ) => {
    try {
      const response = await BundleOutWardService.getBundleByWorkorderId(
        page,
        pagesize,
        search,
        id,
        ordering,
        workOrderId,
        addData,
        bundleOutwardId
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchBundleOutWardByWorkOrderRestoreId = createAsyncThunk(
  'bundleoutword/fetchBundleOutWardByWorkOrderId',
  async (
    { page, pagesize, search, id, ordering, workOrderId, restoreData },
    thunkAPI,
  ) => {
    try {
      const response = await BundleOutWardService.getBundleByWorkorderRestoreId(page, pagesize, search, id, ordering, workOrderId, restoreData);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchBundleListExist = createAsyncThunk(
  'bundleoutword/fetchBundleListExist',
  async ({ page, pagesize, search, ordering, bundleId, added, bundleOutwardId }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.getBudlelistExist(page, pagesize, search, ordering, bundleId, added, bundleOutwardId);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteBundleOutwardList = createAsyncThunk(
  'bundleoutword/deleteBundleOutwardList',
  async (id, thunkAPI) => {
    try {
      const response = await BundleOutWardService.deleteBundleOutwardList(id); // Ensure `id` is used here
      return response.data; // Return the ID of the deleted group
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        error.toString();

      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchArchivedBundleOutWardList = createAsyncThunk(
  'bundleoutword/fetchArchivedBundleOutWardList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.getArchiveBundleOutWardList(page, pagesize, search, ordering);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const addBundleItem = createAsyncThunk(
  'bundleoutword/addBundleItem',
  async ({ values }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.addBundleItem(values);
      return response; 
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const restoreBundleItem = createAsyncThunk(
  'bundleoutword/restoreBundleItem',
  async ({ values }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.restoreBundleItem(values);
      return response; 
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const createBundleOutWard = createAsyncThunk(
  'bundleoutword/createBundleOutWard',
  async ({ values }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.createBundleOutWard(values);
      return response; 
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const finalizeBundleOutward = createAsyncThunk(
  'bundleoutword/finalizeBundleOutward',
  async ({ values }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.finalizeBundleOutward(values);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const editBundleOutWard = createAsyncThunk(
  'bundleoutword/editBundleOutWard',
  async ({ SizeId, SizeData }, thunkAPI) => {
    try {
      const response = await BundleOutWardService.editBundleOutWard(SizeId, SizeData);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteBundleOutWard = createAsyncThunk(
  'bundleoutword/deleteBundleOutWard',
  async (id, thunkAPI) => {
    try {
      await BundleOutWardService.deleteBundleOutWard(id);
      return id; 
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const unArchiveBundleOutWard = createAsyncThunk(
  'bundleoutword/unArchiveBundleOutWard',
  async (id, thunkAPI) => {
    try {
      await BundleOutWardService.unArchiveBundleOutWard(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

const initialState = {
  data: [], // Ensure the data is always an empty array initially
  list: [],
  loading: false,
  totalRecord: 0,
  totalPages: 0,
  currentPage: 1,
  status: 'idle',
  error: null,
  hasMore: true,
};

const BundleOutWardSlice = createSlice({
  name: 'bundleoutword',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetBundleOutWardList: state => {
      state.list = []; // This will clear the list
      state.data = [];
      state.totalRecord = 0;
    },
    resetCurrentBundleOutWardPage: state => {
      state.currentPage = 1;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchBundleOutWardList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchBundleOutWardList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Correctly access the data array
        state.totalRecord = action.payload.count || 0;
        state.Outwardcount = action.payload.count; // Set total records
        state.totalPages = Math.ceil(
          (action.payload.count || 0) / action.meta.arg.limit,
        );
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchBundleOutWardList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchBundleListExist.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchBundleListExist.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.results.data || []; // Correctly access the data array
        state.count = action?.payload?.count || 0; // Set total records
        state.totalPages = Math.ceil(
          (action.payload.count || 0) / action.meta.arg.limit,
        ); // Calculate total pages
      })
      .addCase(fetchBundleListExist.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchArchivedBundleOutWardList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchArchivedBundleOutWardList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Correctly access the data array
        state.totalRecord = action.payload.count || 0; // Set total records
        state.totalPages = Math.ceil(
          (action.payload.count || 0) / action.meta.arg.limit,
        ); // Calculate total pages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchArchivedBundleOutWardList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchBundleOutwardById.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchBundleOutwardById.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(fetchBundleOutwardById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(createBundleOutWard.pending, state => {
        state.status = 'loading';
      })
      .addCase(createBundleOutWard.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(createBundleOutWard.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(finalizeBundleOutward.pending, state => {
        state.status = 'loading';
      })
      .addCase(finalizeBundleOutward.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(finalizeBundleOutward.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });

    builder
      .addCase(editBundleOutWard.pending, state => {
        state.status = 'loading';
      })
      .addCase(editBundleOutWard.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const index = state.data.findIndex(
          Size => Size.id === action.payload.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload; // Update the die size in the state
        }
      })
      .addCase(editBundleOutWard.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(deleteBundleOutwardList.pending, state => {
        state.loading = true;
      })
      .addCase(deleteBundleOutwardList.fulfilled, (state, action) => {
        state.status = false;
      })
      .addCase(deleteBundleOutwardList.rejected, (state, action) => {
        state.loading = false;

      });
    builder
      .addCase(unArchiveBundleOutWard.pending, state => {
        state.status = 'loading';
      })
      .addCase(unArchiveBundleOutWard.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
      })
      .addCase(unArchiveBundleOutWard.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetBundleOutWardList, resetCurrentBundleOutWardPage } = BundleOutWardSlice.actions;
const { reducer } = BundleOutWardSlice;
export default reducer;